import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from 'src/app/vme-common.module';
import { VmeDirectivesModule } from 'src/app/vme-directives.module';
import { VmePipesModule } from 'src/app/vme-pipes.module';
import { TableModule } from 'primeng/table';
import { SearchNonMovementTransactionsComponent } from './search-non-movement-transactions.component';
import { VMEComponentsModule } from 'src/app/vme-components.module';

const routes: Routes = [
  {
    path: '',
    component: SearchNonMovementTransactionsComponent,
    data: { title: 'Non-Movement Descriptions' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TransactionsSearchRoutingModule {}

@NgModule({
  imports: [
    TransactionsSearchRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    TableModule,
    VMEComponentsModule,
  ],
  declarations: [SearchNonMovementTransactionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TransactionsSearchModule {}
